const geyserRepairService = {
  title: "Geyser Repair",
  icon: "♨️",
  rateCardKey: "geyser",
  shortDescription:
    "Heating issue, water leakage, installation, and geyser performance support.",
  longDescription:
    "Book geyser support for heating problems, thermostat suspicion, water leakage, and installation / uninstallation support.",
  consultationNote:
    "Coil, thermostat, PCB, or internal electrical issues require inspection before final quote.",
  responsePromise:
    "Assignment depends on geyser type, mounting setup, and issue type.",
  warrantyPolicy:
    "Support depends on existing unit condition and actual repair performed.",
  subServices: [
    {
      id: "geyser-inspection",
      title: "Geyser Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for not heating, low heating, leakage, or power-side symptoms.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "geyser-heating-issue",
      title: "Heating Issue Support",
      icon: "🔥",
      group: "Repair",
      description:
        "Basic support for heating performance issues pending actual diagnosis.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "geyser-leakage",
      title: "Leakage / Outlet Issue",
      icon: "💧",
      group: "Repair",
      description:
        "Support for outlet leakage, fitting issue, or visible water escape symptoms.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "geyser-installation",
      title: "Geyser Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic installation support for suitable wall-mounted geyser setups.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default geyserRepairService;